import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Table, TableColumn } from 'tea-component';
import ReportCard from '../../../components/ReportCard';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { buildProjectColumn } from '../../../utils/columns';
import { CARD_TITLE } from './utils';
import { BoolFlag } from '@gp/enums/common';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportOtherOrMiscellaneousVO } from '@gp/types/dpsReport/v2';

interface IReviewMiscellaneousProps extends IBaseProps {
  // 模块数据
  value: IDPSReportOtherOrMiscellaneousVO[];
}

const ProjectColumn = buildProjectColumn({ header: 'Category', width: 400 });

const ReviewMiscellaneous: React.FC<IReviewMiscellaneousProps> = (props) => {
  const { style, className, value: records } = props;

  const columns = useMemo<TableColumn<IDPSReportOtherOrMiscellaneousVO>[]>(
    () => [
      // @ts-ignore
      {
        ...ProjectColumn,
        render: (cvm, ...restParams) => {
          const { is_custom: isCustom = BoolFlag.True, project } = cvm || {};
          // 不是自定义project，则按照gpop系统通用project形式渲染
          // @ts-ignore
          if (isCustom === BoolFlag.False) return ProjectColumn?.render(cvm, ...restParams);
          return <span style={{ fontWeight: 700 }}>{project || '-'}</span>;
        },
      },
      CommonColumnBuilders.buildRichTextColumn({
        key: 'action_item',
        header: 'Current Progress/Action Items',
      }),
    ],
    [],
  );

  return (
    <ReportCard
      style={style}
      className={classnames('dbg-dps-report__miscellaneous-table-card', className)}
      title={CARD_TITLE}
    >
      <Table
        className="dbg-dps-report__boeder-table"
        columns={columns}
        records={records}
        recordKey={getRecordKeyOfMockable}
      />
    </ReportCard>
  );
};

export default ReviewMiscellaneous;
